import { CSSProperties } from 'react';

import { ViewMessageType } from '@/enums/viewEnums.ts';

export const getContainerStyle = (type: ViewMessageType): CSSProperties => {
  switch (type) {
    case ViewMessageType.INBOX:
      return inboxContainerStyle;
    case ViewMessageType.OUTBOX:
      return outboxContainerStyle;
    default:
      return systemContainerStyle;
  }
};

export const getMessageStyle = (type: ViewMessageType): CSSProperties => {
  switch (type) {
    case ViewMessageType.INBOX:
      return inboxMessageStyle;
    case ViewMessageType.OUTBOX:
      return outboxMessageStyle;
    case ViewMessageType.MATCH:
      return matchMessageStyle;
    default:
      return systemMessageStyle;
  }
};

const messageItemContainerStyle: CSSProperties = {
  color: 'black',
  display: 'flex',
  width: '100%',
  margin: '1px'
};

const inboxContainerStyle: CSSProperties = {
  justifyContent: 'flex-start',
  ...messageItemContainerStyle
};

const outboxContainerStyle: CSSProperties = {
  justifyContent: 'flex-end',
  ...messageItemContainerStyle
};

const systemContainerStyle: CSSProperties = {
  justifyContent: 'center',
  ...messageItemContainerStyle
};

const messageStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  padding: '8px',
  borderRadius: '15px',
  maxWidth: '85%',
  position: 'relative',
  boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
};

const inboxMessageStyle: CSSProperties = {
  ...messageStyle,
  alignItems: 'flex-start',
  background: '#ffffff',
  borderRadius: '15px 15px 15px 0' // Remove bottom-left rounding for tail
};

const outboxMessageStyle: CSSProperties = {
  ...messageStyle,
  alignItems: 'flex-end',
  background: '#fffdf7',
  color: '#2E2E2E',
  borderRadius: '15px 15px 0 15px',
  fontWeight: 500,
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
};

export const matchMessageStyle: CSSProperties = {
  alignItems: 'center',
  color: '#b4b6bc',
  boxShadow: 'none',
  textAlign: 'center',
  display: 'flex',
  fontSize: '14px',
  flexDirection: 'column',
  justifyContent: 'center'
};

export const systemMessageStyle: CSSProperties = {
  alignItems: 'center',
  color: '#a9a9a9',
  boxShadow: 'none',
  textAlign: 'center',
  display: 'flex',
  fontSize: '10px',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '7px',
  width: 'fit-content',
  margin: '0 auto'
};

export const messageAvatarStyle: CSSProperties = {
  width: 32,
  height: 32,
  borderRadius: '50%',
  marginRight: 8,
  flexShrink: 0
};

export const specialEventSystemMessage: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  fontSize: '14px',
  paddingBottom: 10,
  borderRadius: 20,
  backgroundColor: 'rgba(155,155,155,0.3)',
  backdropFilter: 'blur(20px)',
  padding: '6px 12px'
};

export const baitMessageStyle: CSSProperties = {
  ...specialEventSystemMessage,
  marginBottom: 10,
  backgroundColor: '#F85A89'
};

export const textMessageStyle: CSSProperties = {
  padding: '1px 2px',
  margin: '2px',
  fontWeight: 'normal',
  fontSize: '14px',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  hyphens: 'auto'
};
